import { configureStore } from "@reduxjs/toolkit";
import patientReducer from "./reducers/patientSlice";
import userReducer from "./reducers/userSlice";

const store = configureStore({
  reducer: {
    patients: patientReducer,
    user: userReducer,
  },
});

export default store;
